import {
  AggregateFunction,
  AggregatePeriod,
  ConditionComparator,
  PayoutFrequency,
  PlanCapPayoutReset,
} from '@/graphql/generated/graphql';

export const CapPayoutReset = [
  {
    value: PlanCapPayoutReset.PerEvent,
    title: 'per Each Event',
  },
  {
    value: PlanCapPayoutReset.PerDay,
    title: 'per Day',
  },
  {
    value: PlanCapPayoutReset.PerWeek,
    title: 'per Calendar Week',
  },
  {
    value: PlanCapPayoutReset.PerMonth,
    title: 'per Calendar Month',
  },
  {
    value: PlanCapPayoutReset.PerQuarter,
    title: 'per Quarter',
  },
  {
    value: PlanCapPayoutReset.PerYear,
    title: 'per Calendar Year',
  },
  {
    value: PlanCapPayoutReset.Never,
    title: 'Never',
  },
];

export const ConditionComparators = [
  {
    value: ConditionComparator.EqualTo,
    title: 'equals',
  },
  {
    value: ConditionComparator.NotEqualTo,
    title: 'not equal to',
  },
  {
    value: ConditionComparator.LessThan,
    title: '<',
  },
  {
    value: ConditionComparator.GreaterThan,
    title: '>',
  },
  {
    value: ConditionComparator.LessThanEqualTo,
    title: '≤',
  },
  {
    value: ConditionComparator.GreaterThanEqualTo,
    title: '≥',
  },
  {
    value: ConditionComparator.Contains,
    title: 'contains',
  },
  {
    value: ConditionComparator.Excludes,
    title: 'excludes',
  },
];

export const AttributeComparators = [
  {
    value: '=',
    title: '=',
  },
  {
    value: '<',
    title: '<',
  },
  {
    value: '>',
    title: '>',
  },
  {
    value: '~',
    title: 'contains',
  },
];

export const PayoutFrequencies = [
  {
    value: PayoutFrequency.OnEvent,
    title: 'Event happens',
  },
  {
    value: PayoutFrequency.EndDay,
    title: 'End of day',
  },
  {
    value: PayoutFrequency.EndWeek,
    title: 'End of week',
  },
  {
    value: PayoutFrequency.EndMonth,
    title: 'End of month',
  },
  {
    value: PayoutFrequency.EndYear,
    title: 'End of year',
  },
  {
    value: PayoutFrequency.EndPlan,
    title: 'End of plan',
  },
  {
    value: PayoutFrequency.EndQuarter,
    title: 'End of quarter',
  },
  {
    value: PayoutFrequency.ManualPayout,
    title: 'Payout is generated',
  },
  {
    value: PayoutFrequency.NewUserAdded,
    title: 'New user is added',
  },
  {
    value: PayoutFrequency.Custom,
    title: 'Custom',
  },
];

export const AggregateFunctionList = [
  {
    value: AggregateFunction.None,
    title: 'Value',
  },
  {
    value: AggregateFunction.Total,
    title: 'Total value',
  },
  {
    value: AggregateFunction.Avg,
    title: 'Average value',
  },
  {
    value: AggregateFunction.Min,
    title: 'Min value',
  },
  {
    value: AggregateFunction.Max,
    title: 'Max value',
  },
  {
    value: AggregateFunction.Count,
    title: 'Count',
  },
];

export const AggregatePeriodList = [
  {
    value: AggregatePeriod.LastDay,
    title: 'Last day',
  },
  {
    value: AggregatePeriod.LastWeek,
    title: 'Last week',
  },
  {
    value: AggregatePeriod.LastMonth,
    title: 'Last month',
  },
  {
    value: AggregatePeriod.Last_90Days,
    title: 'Last 90 days',
  },
  {
    value: AggregatePeriod.LastYear,
    title: 'Last year',
  },
  {
    value: AggregatePeriod.AllTime,
    title: 'All time',
  },
  {
    value: AggregatePeriod.CalendarYear,
    title: 'Calendar year',
  },
  {
    value: AggregatePeriod.CalendarMonth,
    title: 'Calendar month',
  },
  {
    value: AggregatePeriod.CalendarWeek,
    title: 'Calendar week',
  },
  {
    value: AggregatePeriod.CurrentCalendarQuarter,
    title: 'Current calendar quarter',
  },
  {
    value: AggregatePeriod.PlanPeriod,
    title: 'Plan period',
  },
  {
    value: AggregatePeriod.Custom,
    title: 'Custom',
  },
];
